import { combineReducers } from 'redux';
import { status } from './status/status.reducer';

export const vendor = combineReducers({ status });
